<template>
  <Breadcrumbs
    :prefectures="prefectures"
    :occupations="occupations"
    :industries="industries"
    :skills="skills"
  />
  <div v-if="isLoading">
    <div class="placeholder">
      <div
        class="flex-wrap flex-md-nowrap row container-fluid mt-0 mx-0 mb-md-0 mb-5 gap-3 justify-content-center"
      >
        <div class="w-317x col-md-4 d-md-flex d-none p-0 align-items-start">
          <div class="placeholder-text agent-search-skelton-body"></div>
        </div>
        <div class="col-md-6 p-0 mt-0 flex-grow-1 mw-634x">
          <div class="placeholder-text agent-search-skelton-body"></div>
        </div>
        <div class="col-md-2 mb-md-0 mb-5 w-250x px-0">
          <div class="placeholder-text agent-search-skelton-body"></div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="job-search-container row container-fluid mt-5d5 mt-md-0 mx-0 mb-md-0 mb-5 gap-3 justify-content-center"
  >
    <div class="w-317x col-md-4 d-md-flex d-none p-0 align-items-start">
      <JobSearch
        v-if="screenWidth > 768"
        :prefectures="prefectures"
        :occupations="occupations"
        :industries="industries"
        :skills="skills"
        :sort="sort"
        :incomes="incomes"
        :initial-total-result="totalResult"
        :list-condition-search="listConditionSearch"
        :total-condition-search="totalConditionSearch"
        @searchJob="onChangeResultSearch"
        @getListConditionSearch="getListConditionSearch"
      />
    </div>
    <div class="d-md-none d-block">
      <div class="d-flex justify-content-around">
        <button
          type="button"
          class="btn btn-primary rounded-4x col-6 d-flex justify-content-center align-items-center mw-184x"
          data-bs-toggle="modal"
          data-bs-target="#jobCondition"
        >
          <div class="flex-grow-1 size-12 lh-12">検索条件</div>
          <img
            src="@/assets/images/icons/zoom.svg"
            role="button"
            class="border rounded-md-circle border-third p-0d25"
            data-bs-dismiss="modal"
          />
        </button>
      </div>

      <!-- Modal -->
      <ModalBase
        ref="modalListConditionSearchAgent"
        is-show-add-button
        element="modalListConditionSearchAgentElement"
        title="保存した検索条件"
        modal-type="mx-4"
        header-background="bg-blue-primary"
        btn-colse-color="btn-close-white"
        color-text="text-white"
      >
        <template #body>
          <div class="text-center bg-grey-05 py-2">
            <img src="@/assets/images/icons/arrow-left-blue.svg" alt="Back icon" />
            <span
              class="ms-2 color-blue-primary cursor-pointer"
              data-bs-toggle="modal"
              data-bs-target="#jobCondition"
            >
              条件設定に戻る
            </span>
          </div>
          <div class="list-job-container overflow-y-scroll bg-white">
            <div v-if="totalConditionSearch == 0">
              <p class="text-center">保存した検索条件はありません</p>
            </div>
            <div
              v-for="searchCondition in listConditionSearch"
              :key="searchCondition.id"
              class="border-bottom px-4"
            >
              <div class="d-flex justify-content-between">
                <div
                  class="d-flex cursor-pointer"
                  data-bs-dismiss="modal"
                  @click="onApplySearchCondition(searchCondition)"
                >
                  <img src="@/assets/images/icons/arrow_curved_left.svg" alt="Back icon" />
                  <p class="text-black my-3 mx-2 truncate-text w-16">
                    {{ searchCondition.title }}
                  </p>
                </div>
                <img
                  src="@/assets/images/icons/trash_grey.svg"
                  alt="Trash icon"
                  class="cursor-pointer"
                  @click="
                    onOpenModaConditionSearchConfirm(searchCondition.id, searchCondition.title)
                  "
                />
              </div>
            </div>
          </div>
        </template>
      </ModalBase>

      <div id="confirmDeleteSearchCondition" class="modal fade" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="d-flex justify-content-end px-3 pt-3">
              <button role="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body p-0">
              <div class="d-flex justify-content-center p-0">
                <h6 class="m-2 px-4">｢{{ titleItemSearch }}｣ を削除しますか？</h6>
              </div>
              <div class="h-48x d-flex justify-content-center my-4">
                <button
                  type="button"
                  class="btn-center btn-primary bg-white py-2 px-4 color-blue-primary size-12 pe-auto w-8"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  キャンセル
                </button>
                <button
                  type="button"
                  class="btn-center btn-primary py-2 px-4 ms-4 text-white size-12 pe-auto w-8"
                  data-bs-dismiss="modal"
                  @click="onDeleteSearchCondition(idItemSearch)"
                >
                  削除する
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="jobCondition" class="modal fade" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-blue-primary d-flex justify-content-between p-0">
              <p class="m-2 text-white">検索条件</p>
              <img
                src="@/assets/image/icon-close-white.svg"
                role="button"
                class="border rounded-circle border-third p-0d25"
                data-bs-dismiss="modal"
              />
            </div>
            <div class="modal-body p-0 no-bounce-x">
              <JobSearchSP
                v-if="screenWidth <= 768"
                ref="jobSearchSPRef"
                :sort="sort"
                :prefectures="prefectures"
                :occupations="occupations"
                :industries="industries"
                :skills="skills"
                :incomes="incomes"
                :list-condition-search="listConditionSearch"
                :total-condition-search="totalConditionSearch"
                :initial-total-result="totalResult"
                @searchJob="onChangeResultSearch"
                @createJobCondition="onSaveJobCondition"
                @getListConditionSearch="getListConditionSearch"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 p-0 mt-3 mt-md-0 flex-grow-1 mw-634x">
      <div
        class="bg-white h-3 d-flex align-items-center mt-md-0 mb-3 position-sticky z-1 job-list-tab"
      >
        <a
          href="javascript:void(0);"
          class="col-6 text-center px-0 link-underline link-underline-opacity-0 opacity-50 d-inline-block size-12 fw-bold color-blue-primary menu-list-job d-inline-block"
          @click="redirectToDirectJobs"
        >
          ダイレクト求人
          <img
            src="@/assets/images/icons/question.svg"
            alt="question icon"
            class="ms-2 mb-1"
            data-bs-toggle="tooltip"
            data-bs-offset="0, 10"
            data-bs-placement="bottom"
            data-bs-custom-class="tooltip-third"
            data-bs-html="true"
            data-bs-title="「ダイレクト求人」は、掲載する企業の求人に求職者が直接応募ができる求人形式です。<br>※ダイレクトサービスご利用の方のみご応募ができます。"
          />
        </a>
        <a
          href="#"
          class="col-6 text-center px-0 link-underline link-underline-opacity-0 d-inline-block size-12 fw-bold color-blue-primary menu-list-job menu-active d-inline-block"
        >
          エージェント求人
          <img
            src="@/assets/images/icons/question.svg"
            alt="question icon"
            class="ms-2 mb-1"
            data-bs-toggle="tooltip"
            data-bs-offset="0, 10"
            data-bs-placement="bottom"
            data-bs-custom-class="tooltip-third"
            data-bs-html="true"
            data-bs-title="「エージェント求人」は、アイムファクトリーが企業から依頼され掲載する求人に応募できる求人形式です。<br>※エージェントサービスご利用の方のみご応募ができます。"
          />
        </a>
      </div>
      <h1 class="size-16 fw-bold d-md-flex m-0 text-center">
        {{ h1Title }}
      </h1>
      <div class="d-md-flex m-0 text-center">
        <p class="size-14 fw-bold mb-0">
          この条件の求人数
          <span class="size-20 px-2">
            <vue3-autocounter
              ref="counter"
              :start-amount="0"
              :end-amount="totalResult"
              :duration="1"
              :autoinit="true"
              @finished=""
            />
          </span>
          <span>件</span>
        </p>
        <div class="d-flex ms-md-3 justify-content-center order-2">
          <div class="d-flex justify-content-between">
            <select
              v-model="sort"
              class="form-select select-input-primary w-8 h-2d5 size-14 lh-14"
              aria-label="sort-job-label"
              @change="onChangeSortDirection"
            >
              <option v-for="sortItem in sortCondition" :key="sortItem.id" :value="sortItem.value">
                {{ sortItem.text }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div ref="inputListJob" class="list-job-search">
        <div v-for="job in jobs" :key="job.id" class="position-relative">
          <a
            :href="`/jobs/${job.id}?agent=true`"
            class="text-decoration-none text-black"
            target="_blank"
          >
            <article
              :class="`card job-search-card w-100 mb-2 border-0 w-22 mt-3 ${
                !isDisableConsideration(job) ? 'pb-3d5' : 'pb-3'
              }`"
            >
              <div :id="`job-card-${job.id}`" class="card-body p-0">
                <div class="job-page__body py-3 pe-2 ps-3">
                  <div class="size-12 fw-medium">
                    {{ job.company.name }}
                  </div>
                  <div class="job-page__body-title d-flex">
                    <h2
                      class="col-9 size-16 lh-18 fw-bold text-md-decoration-underline flex-grow-1 job-search-card-title"
                    >
                      {{ job.title }}
                    </h2>
                    <div class="d-flex text-end">
                      <div v-if="job.operation_status == 'closed'" class="pe-1">
                        <span class="tag-gray-01 size-10 lh-10">募集終了</span>
                      </div>
                      <div v-if="new Date(job.public_date) >= pastDate" class="pe-1">
                        <span class="tag-pink-01 size-10 lh-10">新着</span>
                      </div>
                    </div>
                  </div>
                  <div class="job-page__body-overview py-3 gap-2">
                    <div>
                      <div class="d-flex p-0 gap-2 flex-wrap">
                        <div
                          v-if="job.occupation_description && job.occupation_description.length > 0"
                          class="job-page__body-overview__place border border-blue-primary rounded-10x h-1d5 d-flex justify-content-center align-items-center px-2"
                        >
                          <img
                            src="@/assets/images/icons/ic_occupation.svg"
                            alt="Occupation icon"
                          />
                          <span class="size-10 ps-1 color-blue-primary">
                            {{ truncateString(job.occupation_description.join(', '), 25, '...') }}
                          </span>
                        </div>
                        <div
                          v-if="job.wage_min || job.wage_max"
                          class="job-page__body-overview__place rounded-10x h-1d5 d-flex justify-content-center align-items-center px-2"
                        >
                          <img src="@/assets/images/icons/ic_income.svg" alt="Income icon" />
                          <span class="size-10 ps-1">
                            {{
                              `${job.wage_min ? job.wage_min + '万円' : ''}
                            ~
                            ${job.wage_max ? job.wage_max + '万円' : ''}`
                            }}
                          </span>
                        </div>
                        <div
                          v-if="job.prefecture_name.length > 0"
                          class="job-page__body-overview__place border border-blue-primary rounded-10x h-1d5 d-flex justify-content-center align-items-center px-2"
                        >
                          <img
                            src="@/assets/images/icons/ic_round-place-blue.svg"
                            alt="Place icon"
                          />
                          <span class="size-10 ps-1 color-blue-primary">
                            {{ truncateString(job.prefecture_name.join(', '), 25, '...') }}
                          </span>
                        </div>
                        <div
                          v-if="job.industry_name.length > 0"
                          class="job-page__body-overview__place border border-blue-primary rounded-10x h-1d5 d-flex justify-content-center align-items-center px-2"
                        >
                          <img src="@/assets/images/icons/ic_industry.svg" alt="Industry icon" />
                          <span class="size-10 ps-1 color-blue-primary">
                            {{ truncateString(job.industry_name.join(', '), 35, '...') }}
                          </span>
                        </div>
                        <div
                          v-if="job.skill_names.length > 0"
                          class="job-page__body-overview__place border border-blue-primary rounded-10x h-1d5 d-flex justify-content-center align-items-center px-2"
                        >
                          <img src="@/assets/images/icons/gear-white.svg" alt="Skill icon" />
                          <span class="size-10 ps-1 color-blue-primary">
                            {{ truncateString(job.skill_names.join(', '), 25, '...') }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="job-page__body-description d-flex flex-column">
                    <div class="fw-bold mb-2">仕事内容</div>
                    <div v-if="isDescriptionLong(job.duties)">
                      <SanitizedHtml
                        :html="
                          job.isShowFullDescription ? job.duties : truncateHtml(job.duties, 200)
                        "
                        class="job-description"
                      />
                      <span
                        class="color-grey-text-des cursor-pointer"
                        @click="handleShowHideDescription(job.id)"
                      >
                        {{ job.isShowFullDescription ? '折りたたむ' : 'もっとみる' }}
                      </span>
                    </div>
                    <div v-else>
                      <SanitizedHtml :html="job.duties" class="job-description" />
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </a>
          <div
            v-if="job.operation_status == 'closed'"
            class="d-flex justify-content-center mb-3 position-absolute bottom-0 start-50 translate-middle-x"
          >
            <span class="tag-gray-01 rounded-24 px-5 py-2 size-12">募集終了</span>
          </div>
          <div
            v-else-if="!isDisableConsideration(job)"
            class="d-flex justify-content-center mb-3 position-absolute bottom-0 start-50 translate-middle-x"
          >
            <button
              v-if="job.consideration && job.consideration.in_consideration == 'yes'"
              type="button"
              name="favorite"
              class="btn bg-grey-05 rounded-24 px-5 py-2 size-12"
              :disabled="favoriteLoadingIds.includes(job.id)"
              @click.prevent="onFavoriteJob(job)"
            >
              <template v-if="favoriteLoadingIds.includes(job.id)">
                <LoadingSpinner img-class="consideration-loading-image" />
              </template>
              <template v-else>
                <img src="@/assets/images/icons/checked.svg" alt="checked icon" class="mb-1 me-1" />
                検討中
              </template>
            </button>
            <button
              v-else
              type="button"
              name="favorite"
              class="btn btn-outline-secondary rounded-24 px-5 py-2 size-12"
              :class="job.status == 'inactive' ? 'btn-disabled' : ''"
              :disabled="favoriteLoadingIds.includes(job.id)"
              @click.prevent="onFavoriteJob(job)"
            >
              <template v-if="favoriteLoadingIds.includes(job.id)">
                <LoadingSpinner img-class="consideration-loading-image" />
              </template>
              <template v-else>
                <img
                  src="@/assets/images/icons/star-border-blue.svg"
                  alt="checked icon"
                  class="mb-1 me-1"
                />
                検討する
              </template>
            </button>
          </div>
        </div>
      </div>
      <div class="pagination d-flex justify-content-center mt-3 mx size-12 text-nowrap">
        <vue-awesome-paginate
          v-model="pagy.page"
          :on-click="navigateToPage"
          :total-items="pagy.count"
          :items-per-page="30"
          :max-pages-shown="screenWidth <= 768 ? getMaxVisiblePagesSP() : getMaxVisiblePages()"
          :show-ending-buttons="screenWidth <= 768 ? false : true"
          :show-breakpoint-buttons="false"
          :hide-prev-next-when-ends="true"
          first-page-content="最初へ"
          last-page-content="最後へ"
        >
          <template #prev-button>
            <a
              class="page-link cursor-pointer w-2 h-2 d-flex justify-content-center align-items-center border-0 rounded-4x"
              aria-label="previous"
            >
              <img src="@/assets/images/icons/paginate-angle-left.svg" alt="" />
            </a>
          </template>

          <template #next-button>
            <a
              class="page-link cursor-pointer w-2 h-2 d-flex justify-content-center align-items-center border-0 rounded-4x"
              aria-label="next"
            >
              <img src="@/assets/images/icons/paginate-angle-right.svg" alt="" />
            </a>
          </template>
        </vue-awesome-paginate>
      </div>
    </div>

    <div class="col-md-2 mb-md-0 mb-5 w-250x px-0">
      <div v-if="jobViewHistory.length" class="bg-white-primary w-100 border border-third rounded">
        <div class="company-information overflow-y-scroll">
          <div class="company-information__header border-bottom border-third py-3">
            <h2 class="text-center size-14 color-blue-primary mb-0">閲覧履歴</h2>
          </div>
          <div
            v-for="job in jobViewHistory"
            :key="job.jobId"
            class="company-information__body border-bottom size-12 px-2"
          >
            <a
              class="size-12 p-3 border-bottom link-info text-black text-decoration-none cursor-pointer"
              target="_blank"
              rel="noopener noreferrer"
              :href="`/jobs/${job.jobId}?agent=true`"
            >
              <h4 class="fw-bold size-12 text-decoration-underline">
                {{ job.title }}
              </h4>
              <div class="d-block p-0 gap-2">
                <div
                  v-if="job.occupation != ''"
                  class="job-page__body-overview__place rounded-10x h-1d5 d-flex align-items-center px-2"
                >
                  <img src="@/assets/images/icons/ic_occupation.svg" alt="Occupation icon" />
                  <span class="size-10 ps-1">{{ truncateString(job.occupation, 25, '...') }}</span>
                </div>
                <div
                  v-if="job.income != ''"
                  class="job-page__body-overview__place rounded-10x h-1d5 d-flex align-items-center px-2"
                >
                  <img src="@/assets/images/icons/ic_income.svg" alt="Income icon" />
                  <span class="size-10 ps-1">{{ job.income }}</span>
                </div>
                <div
                  v-if="job.place != ''"
                  class="job-page__body-overview__place rounded-10x h-1d5 d-flex align-items-center px-2"
                >
                  <img src="@/assets/images/icons/ic_round-place-blue.svg" alt="Place icon" />
                  <span class="size-10 ps-1">{{ truncateString(job.place, 25, '...') }}</span>
                </div>
                <div
                  v-if="job.industry != ''"
                  class="job-page__body-overview__place rounded-10x h-1d5 d-flex align-items-center px-2"
                >
                  <img src="@/assets/images/icons/ic_industry.svg" alt="Industry icon" />
                  <span class="size-10 ps-1">{{ truncateString(job.industry, 25, '...') }}</span>
                </div>
                <div
                  v-if="job.skill != ''"
                  class="job-page__body-overview__place rounded-10x h-1d5 d-flex align-items-center px-2"
                >
                  <img src="@/assets/images/icons/gear-white.svg" alt="Skill icon" />
                  <span class="size-10 ps-1">{{ truncateString(job.skill, 25, '...') }}</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Agent />
  <ScrollToTopButton />
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch, nextTick, computed } from 'vue';
import JobSearch from '@/pages/candidate/job/agent/JobSearch.vue';
import JobSearchSP from '@/pages/candidate/job/agent/JobSearchSP.vue';
import { PaginationType } from '@/types/models/PaginationType';
import {
  createAgentConsideration,
  deleteConditionJobSearch,
  getAgentJobs,
  getListConditionJobSearch,
  updateAgentConsideration,
} from '@/apis/job.api';
import { getIndustries, getOccupations, getPrefectures, getSkills } from '@/apis/candidate';
import { PrefecturePrimary } from '@/types/models/prefecture';
import { OccupationPrimary } from '@/types/models/occupation';
import { IndustryType } from '@/types/models/industryType';
import { SkillsType } from '@/types/models/skill';
import Vue3Autocounter from 'vue3-autocounter';
import { truncateString } from '@/utils/string';
import { getIncomes } from '@/utils/getIncomes';
import { IncomePrimary } from '@/types/models/income';
import { SearchConditionType } from '@/types/models/searchConditionType';
import { Modal, Tooltip } from 'bootstrap';
import ModalBase from '@/components/common/ModalBase/index.vue';
import { AGENT_SEARCH_PATH, SEARCH_PATH, CANDIDATE_SIGN_UP_PATH } from '@/constant/routers/path';
import Agent from '@/components/common/PlatformModal/Agent.vue';
import router from '@/routers';
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head';
import ScrollToTopButton from '@/components/ScrollToTopButton.vue';
import Breadcrumbs from '@/pages/candidate/job/Breadcrumbs.vue';
import LoadingSpinner from '@/components/LoadingSpinner/index.vue';
import AuthService from '@/services/auth.service';
import SanitizedHtml from '@/components/common/SanitizedHtml.vue';
const route = useRoute();

const prefectures = ref<PrefecturePrimary[]>([]);
const occupations = ref<OccupationPrimary[]>([]);
const incomes = ref<IncomePrimary[]>([]);
const industries = ref<IndustryType[]>([]);
const skills = ref<SkillsType[]>([]);
const isLoading = ref<boolean>(true);
const screenWidth = ref<number>(window.innerWidth);
const totalConditionSearch = ref(0);
const listConditionSearch = ref();
const idItemSearch = ref(0);
const titleItemSearch = ref('');
const platform = ref();
const jobViewHistory = ref();
const userLoggedIn = ref(false);

const modalListConditionSearchAgent = ref<InstanceType<typeof ModalBase> | null>(null);
const modalElement = ref();

const jobSearchSPRef = ref<InstanceType<typeof JobSearchSP> | null>(null);

const updateScreenWidth = (): void => {
  screenWidth.value = window.innerWidth;
};

const initPagination = {
  count: null,
  from: null,
  to: null,
  next: null,
  prev: null,
  page: null,
  pages: null,
};

const initialData = {
  search_word: null,
  occupations: null,
  locations: null,
  annual_min_income: null,
  annual_max_income: null,
  industries: null,
  skills: null,
};
const currentDate = new Date();
const pastDate = new Date(currentDate);
pastDate.setDate(currentDate.getDate() - 7);

const pagy = ref<PaginationType>(initPagination);
const jobs = ref();
const data = ref(initialData);
const totalResult = ref();
const inputListJob = ref(null);
const jobSearchContainer = ref(null);
const perPage = 30;

const updateJobSearchPosition = (): void => {
  if (jobSearchContainer.value && inputListJob.value) {
    const containerRect = jobSearchContainer.value.getBoundingClientRect();
    const listRect = inputListJob.value.getBoundingClientRect();
    const jobSearch = jobSearchContainer.value.querySelector('.job-search');
    const listConditionSearch = jobSearchContainer.value.querySelector('.list-condition-search');

    if (jobs.value.length <= 1) {
      jobSearch?.style.setProperty('position', 'static', 'important');
      listConditionSearch?.style.setProperty('position', 'static', 'important');
      return;
    }

    if (jobSearch) {
      if (containerRect.top <= 0) {
        const maxTop = listRect.bottom - jobSearch.offsetHeight;
        const newTop = Math.min(100, maxTop);

        jobSearch.style.position = 'fixed';
        jobSearch.style.top = `${newTop}px`;
        jobSearch.style.width = `${containerRect.width}px`;
      } else {
        jobSearch.style.position = 'static';
      }
    }
  }
};

const handleScroll = (): void => {
  requestAnimationFrame(updateJobSearchPosition);
};

onMounted(async () => {
  window.scrollTo(0, 0); //placeholderを画面内に表示させるための対応

  await Promise.all([getJobs(), getAllData(), getListConditionSearch()]).catch((error) => {
    console.error('Error loading additional data:', error);
  });

  isLoading.value = false;

  window.scrollTo(0, 0); //求人情報反映後にスクロール位置を0にするための対応
  window.addEventListener('resize', updateScreenWidth);
  nextTick(() => {
    updateJobSearchPosition();
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', updateJobSearchPosition);
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
      customClass: 'tooltip-third',
    });
  });
  jobViewHistory.value = JSON.parse(localStorage.recentlyJob || '[]');

  // ログインチェック
  AuthService.isAuthenticated().then((isAuthenticated) => {
    userLoggedIn.value = isAuthenticated;
  });

  useHead({
    title,
    meta: [
      {
        name: 'description',
        content: description,
      },
      {
        name: 'keywords',
        content: keywords,
      },
      {
        property: 'og:site_name',
        content: '社内SE転職ナビ',
      },
      {
        property: 'og:image',
        content: 'https://se-navi.jp/ogp_se.png',
      },
      {
        property: 'og:title',
        content: title,
      },
      {
        property: 'og:description',
        content: description,
      },
      {
        property: 'og:url',
        content: url,
      },
      {
        property: 'twitter:image',
        content: 'https://se-navi.jp/ogp_se.png',
      },
      {
        name: 'twitter:title',
        content: title,
      },
      {
        name: 'twitter:description',
        content: description,
      },
    ],
  });
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateScreenWidth);
  useHead({
    title: '',
    meta: [],
  });
});

const updateMetaTag = (): void => {
  const existingMeta = document.querySelector('meta[name="robots"]');
  if (existingMeta) {
    document.head.removeChild(existingMeta);
  }

  if (jobs.value.length === 0) {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
  }
};

watch(
  () => jobs.value,
  () => {
    updateMetaTag();
  }
);
let isUpdatingPage = false;
watch(
  () => route.query.page,
  () => {
    if (!isUpdatingPage) {
      getJobs();
    }
  }
);

const onOpenModaConditionSearchConfirm = (id: number, title: string): void => {
  idItemSearch.value = id;
  titleItemSearch.value = title;
  const modalElementDOM: HTMLElement | null = document.getElementById(
    'confirmDeleteSearchCondition'
  );
  if (!modalElementDOM) return;
  modalElement.value = new Modal(modalElementDOM);
  modalElement.value.show();
};

const onOpenModalPlatform = (): void => {
  document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
  const modalElementDOM: HTMLElement | null = document.getElementById('platformAgentModal');
  if (!modalElementDOM) return;
  modalElement.value = new Modal(modalElementDOM);
  modalElement.value.show();
};

const sortCondition = ref([
  { id: 1, text: '新着順', value: 'publication_date_senavi' },
  { id: 2, text: '年収順', value: 'wage_max' },
]);
const sort = ref('publication_date_senavi');

const getJobs = async (): Promise<void> => {
  // パフォーマンス改善のため、ローカルで年収データを取得する
  // agentではクエリから取得できるincome_idではなく,APIから取得するdisplay_amountを使用している
  // APIから取得すると優先的に取得したい求人取得APIの実行が遅れる
  incomes.value = getIncomes();
  const minIncome = incomes.value.find((income) => income.id === Number(route.query.wage_min));
  const maxIncome = incomes.value.find((income) => income.id === Number(route.query.wage_max));
  const currentPage = Math.max(Number(route.query.page) || 1, 1);
  const params: Record<string, any> = {
    include: [
      'corporation',
      'prefectures',
      'hrc_skills',
      'hrc_job_types',
      'corporation.corporation_industries',
    ],
    'filter[have_hrc_job_types_any]': route.query.job_types,
    'filter[with_prefecture]': route.query.prefectures,
    'filter[have_corporation_industries_any]': route.query.industries,
    'filter[have_hrc_skills_any]': route.query.skills,
    'filter[contain_keywords_any]': route.query.keywords?.trim().split(/[\s　]+/) || [], // Split whitespace full-width or half-width
    sort: '-' + sort.value,
    'page[size]': perPage,
    'page[number]': currentPage,
  };
  if (minIncome || maxIncome) {
    params['filter[with_wage_range]'] = [
      minIncome?.display_amount ? getNumberIncome(minIncome?.display_amount) : null,
      maxIncome?.display_amount ? getNumberIncome(maxIncome?.display_amount) : null,
    ];
  }

  const response = await getAgentJobs(params);
  const pageInvalid = currentPage + 1 > response.data.meta.total_pages;
  if (response.status === 200) {
    jobs.value = response.data.jobs;
    platform.value = response.data.platform;
    totalResult.value = response.data.meta.total_records;
    pagy.value = {
      count: totalResult.value,
      from: 1,
      to: 4,
      page: currentPage,
      pages: response.data.meta.total_pages,
      prev: (currentPage || 1) - 1,
      next: pageInvalid ? null : (currentPage || 1) + 1,
    };
  }

  if (pageInvalid) {
    isUpdatingPage = true;
    router.push({
      path: AGENT_SEARCH_PATH,
      query: {
        ...route.query,
        page: currentPage === 1 ? undefined : currentPage,
      },
    });
    isUpdatingPage = false;
  }
};

const onChangeResultSearch = (resultSearch: any, dataSearch: any): void => {
  jobs.value = resultSearch.data.jobs;
  data.value = dataSearch;
  totalResult.value = resultSearch.data.meta.total_records;
  const currentPage = Math.max(Number(route.query.page) || 1, 1);
  const pageInvalid = currentPage + 1 > resultSearch.data.meta.total_pages;
  pagy.value = {
    count: totalResult.value,
    from: 1,
    to: 4,
    page: currentPage,
    pages: resultSearch.data.meta.total_pages,
    prev: (currentPage || 1) - 1,
    next: pageInvalid ? null : (currentPage || 1) + 1,
  };
  const paramsUrl = {
    ...route.query,
    page: undefined,
    keywords: dataSearch.keywords,
  };
  router.push({ path: AGENT_SEARCH_PATH, query: paramsUrl });
};

const onChangeSortDirection = async (): Promise<void> => {
  const params: Record<string, any> = {
    include: [
      'corporation',
      'prefectures',
      'hrc_skills',
      'hrc_job_types',
      'corporation.corporation_industries',
    ],
    'filter[have_hrc_job_types_any]': data.value.occupations,
    'filter[with_prefecture]': data.value.locations,
    'filter[have_corporation_industries_any]': data.value.industries,
    'filter[have_hrc_skills_any]': data.value.skills,
    'filter[contain_keywords_any]': data.value.keywords?.trim().split(/[\s　]+/) || [], // Split whitespace full-width or half-width
    sort: '-' + sort.value,
    'page[size]': perPage,
    'page[number]': 1,
  };
  if (data.value.annual_min_income || data.value.annual_max_income) {
    params['filter[with_wage_range]'] = [
      data.value.annual_min_income,
      data.value.annual_max_income,
    ];
  }
  const response = await getAgentJobs(params);
  if (response.status == 200) {
    jobs.value = response.data.jobs;
    totalResult.value = response.data.meta.total_records;
    pagy.value = {
      count: totalResult.value,
      from: 1,
      to: 4,
      page: 1,
      pages: response.data.meta.total_pages,
      prev: 0,
      next: 2,
    };
    totalResult.value = pagy.value.count;
  }
};

const onApplySearchCondition = (searchCondition: SearchConditionType): void => {
  jobSearchSPRef.value?.onApplySearchCondition(searchCondition);
};

const getListConditionSearch = async (): Promise<void> => {
  const response = await getListConditionJobSearch();
  if (response.status == 200 && response?.data?.job_search_conditions) {
    listConditionSearch.value = response?.data?.job_search_conditions.filter(
      (item) => item.service_type_flag != false
    );
    totalConditionSearch.value = listConditionSearch?.value?.length;
  }
};

const onDeleteSearchCondition = async (id: number): Promise<void> => {
  const response = await deleteConditionJobSearch(id);
  if (response.status == 200) {
    const inputSaveJobAvailable = document.getElementById('save-job-available');
    const inputSaveJobUnavailable = document.getElementById('save-job-unavailable');
    await getListConditionSearch();
    if (totalConditionSearch.value < 10 && inputSaveJobAvailable && inputSaveJobUnavailable) {
      inputSaveJobAvailable.classList.toggle('d-none');
      inputSaveJobAvailable.classList.toggle('d-block');
      inputSaveJobUnavailable.classList.toggle('d-none');
      inputSaveJobUnavailable.classList.toggle('d-block');
    }
  }
};

const onSaveJobCondition = (): void => {
  getListConditionSearch();
};

const getNumberIncome = (income: string): number | null => {
  const numberRegex = /\d+/;
  const match = income.match(numberRegex);

  if (match) {
    const number = parseInt(match[0], 10);
    return number;
  }
  return null;
};

const navigateToPage = async (page: number): Promise<void> => {
  const paramsUrl = { ...route.query, page: page };
  router.push({ path: AGENT_SEARCH_PATH, query: paramsUrl });
  if (window.scrollY > 0) window.scrollTo(0, 0);
  const params: Record<string, any> = {
    include: [
      'corporation',
      'prefectures',
      'hrc_skills',
      'hrc_job_types',
      'corporation.corporation_industries',
    ],
    'filter[have_hrc_job_types_any]': data.value.occupations,
    'filter[with_prefecture]': data.value.locations,
    'filter[have_corporation_industries_any]': data.value.industries,
    'filter[have_hrc_skills_any]': data.value.skills,
    'filter[contain_keywords_any]': data.value.keywords?.trim().split(/[\s　]+/) || [], // Split whitespace full-width or half-width
    sort: '-' + sort.value,
    'page[size]': perPage,
    'page[number]': page,
  };
  if (data.value.annual_min_income || data.value.annual_max_income) {
    params['filter[with_wage_range]'] = [
      data.value.annual_min_income,
      data.value.annual_max_income,
    ];
  }
  const response = await getAgentJobs(params);
  const pageInvalid = page + 1 > response.data.meta.total_pages;
  if (response.status == 200) {
    jobs.value = response.data.jobs;
    totalResult.value = response.data.meta.total_records;
    pagy.value = {
      count: totalResult.value,
      from: 1,
      to: 4,
      page: page,
      pages: response.data.meta.total_pages,
      prev: page - 1,
      next: pageInvalid ? null : page + 1,
    };
  }
};

const favoriteLoadingIds = ref<number[]>([]);

const onFavoriteJob = async (job: any): Promise<void> => {
  if (!userLoggedIn.value) {
    window.location.href = CANDIDATE_SIGN_UP_PATH;
    return;
  }

  if (platform.value === 'direct') {
    onOpenModalPlatform();
    return;
  }
  favoriteLoadingIds.value.push(job.id);
  job.consideration ? await updateFavoriteJob(job) : await createFavoriteJob(job);

  favoriteLoadingIds.value = favoriteLoadingIds.value.filter((id) => id !== job.id);
};

const createFavoriteJob = async (job: any): Promise<void> => {
  const response = await createAgentConsideration(job.id);
  if (response.status == 200) {
    await getJobs();
  }
};

const updateFavoriteJob = async (job: any): Promise<void> => {
  const response = await updateAgentConsideration(job.id);
  if (response.status == 200) {
    if (job.consideration.in_consideration == 'yes') {
      job.consideration.in_consideration = 'no';
    } else {
      job.consideration.in_consideration = 'yes';
    }
  }
};

// Get data

const getAllData = async (): Promise<void> => {
  await Promise.all([
    getPrefecturesData(),
    getOccupationsData(),
    getIndustryData(),
    getSkillsData(),
  ]);
};

const getPrefecturesData = async (): Promise<void> => {
  const response = await getPrefectures();
  if (response.status === 200) {
    prefectures.value = response.data;
  }
};

const getOccupationsData = async (): Promise<void> => {
  const response = await getOccupations();
  if (response.status === 200) {
    occupations.value = response.data;
  }
};

const getIndustryData = async (): Promise<void> => {
  const response = await getIndustries();
  if (response.status === 200) {
    industries.value = response.data;
  }
};

const getSkillsData = async (): Promise<void> => {
  const response = await getSkills();
  if (response.status === 200) {
    // エージェントページの場合、`社内SE`カテゴリーのスキルは検索項目に表示しない
    skills.value = response.data.filter((category: { id: number }) => category.id !== 31001);
  }
};

const stripHtmlTags = (html: string): string => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || '';
};

const isDescriptionLong = (jobDescription: string): boolean => {
  const plainText = stripHtmlTags(jobDescription);
  return plainText.length > 200;
};

const handleShowHideDescription = (jobId: number): void => {
  const jobIndex = jobs.value.findIndex((item) => item.id == jobId);
  jobs.value[jobIndex].isShowFullDescription = !jobs.value[jobIndex].isShowFullDescription;
  if (!jobs.value[jobIndex].isShowFullDescription) {
    const cardJobElement = document.getElementById(`job-card-${jobId}`);
    cardJobElement?.scrollIntoView(true);
  }
};

const redirectToDirectJobs = (): void => {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete('agent');
  urlParams.delete('page');
  if (urlParams.has('wage_min')) {
    const value = urlParams.get('wage_min') || '';
    urlParams.delete('wage_min');
    urlParams.set('min_annual_income', value);
  }
  if (urlParams.has('wage_max')) {
    const value = urlParams.get('wage_max') || '';
    urlParams.delete('wage_max');
    urlParams.set('max_annual_income', value);
  }
  window.location.href = `${SEARCH_PATH}&${urlParams.toString()}`;
};

const isDisableConsideration = (job: any): boolean => {
  if (!job.consideration) return false;

  return job.consideration.current_stage_id != 0 && job.consideration.current_stage_id != 2;
};

const truncateHtml = (html: string, maxLength: number): string => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  let truncatedText = '';
  let currentLength = 0;

  const traverseNodes = (node: any): void => {
    if (currentLength >= maxLength) return;

    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent;
      const remainingLength = maxLength - currentLength;

      if (text.length > remainingLength) {
        truncatedText += text.slice(0, remainingLength) + '...';
        currentLength = maxLength;
      } else {
        truncatedText += text;
        currentLength += text.length;
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const clonedNode = node.cloneNode(false);
      for (const child of node.childNodes) {
        traverseNodes(child);
        if (currentLength >= maxLength) break;
      }
      if (currentLength < maxLength) {
        truncatedText += clonedNode.outerHTML;
      }
    }
  };

  traverseNodes(tempDiv);
  return truncatedText;
};

const getParentCategoryName = (ids: string | string[], items: any[]): string => {
  if (!ids || !items) return '';

  // 配列でない場合は配列に変換
  const idArray = Array.isArray(ids) ? ids : [ids];
  const idNums = idArray.map((id) => parseInt(id, 10));

  // 親カテゴリのチェック
  for (const parent of items) {
    if (parent.children) {
      const childIds = parent.children.map((child) => child.id);
      const hasAllChildren = childIds.every((id) => idNums.includes(id));
      const hasOnlyChildren = idNums.every((id) => childIds.includes(id));

      if (hasAllChildren && hasOnlyChildren) {
        return parent.name;
      }
    }
  }

  // 単一のIDの場合の処理
  if (idArray.length === 1) {
    const idNum = idNums[0];
    let found = null;

    items.forEach((parent) => {
      if (parent.id === idNum) {
        found = parent;
      }
      if (parent.children) {
        const child = parent.children.find((child) => child.id === idNum);
        if (child) {
          found = child;
        }
      }
    });

    return found ? found.name : '';
  }

  return '';
};

const getOccupationName = computed(() =>
  getParentCategoryName(route.query.job_types, occupations.value)
);

const getIndustryName = computed(() =>
  getParentCategoryName(route.query.industries, industries.value)
);

const getSkillName = computed(() => getParentCategoryName(route.query.skills, skills.value));

const getPrefectureName = computed(() =>
  getParentCategoryName(route.query.prefectures, prefectures.value)
);

const getDisplayName = computed(() => {
  if (route.query.job_types?.length > 0 && getOccupationName.value) return getOccupationName.value;
  if (route.query.industries?.length > 0 && getIndustryName.value) return getIndustryName.value;
  if (route.query.skills?.length > 0 && getSkillName.value) return getSkillName.value;
  if (route.query.prefectures?.length > 0 && getPrefectureName.value)
    return getPrefectureName.value;
  if (route.query.keywords) return `キーワード：${route.query.keywords}`;
  return '';
});

const h1Title = computed(() => {
  const name = getDisplayName.value;
  return name ? `${name}の社内SE 転職・求人` : 'すべての社内SE 転職・求人';
});

const getPageTitle = (name: string): string => {
  return name
    ? `${name}の社内SE 転職・求人｜IT転職エージェントのキャリア相談 - 社内SE転職ナビ`
    : '社内SE求人数5,000件以上、社内SE 転職・求人検索一覧｜ 社内SE転職ナビ';
};

const getPageDescription = (name: string): string => {
  return name
    ? `${name}のIT転職・求人情報ページ。IT専門のキャリアコンサルタントが最適な求人を紹介。安心のエージェント求人で転職をサポート。社内SEに特化したキャリア支援サービス「社内SE転職ナビ」。`
    : '国内最大級の社内SE・情報システム、転職・求人検索ページです。社内SEに特化したキャリア支援サービス「社内SE転職ナビ」。 大手・優良企業など豊富な求人情報を掲載中。';
};

const getMaxVisiblePages = (): number => {
  if (pagy.value.page <= 6) return Math.min(5 + pagy.value.page - 1, 9);
  if (pagy.value.page >= pagy.value.pages - 5)
    return Math.min(5 + (pagy.value.pages - pagy.value.page), 9);
  return 9;
};

const getMaxVisiblePagesSP = (): number => {
  const paginationDiv = document.querySelector('.pagination');

  // ページが1~3の時はpaginationクラスのdiv配下にあるback-buttonクラスを持ったボタンにd-noneクラスを足す
  if (pagy.value.page >= 1 && pagy.value.page <= 3) {
    const backButton = paginationDiv?.querySelector('.back-button');
    if (backButton) {
      backButton.classList.add('d-none');
    }
  }

  // pagy.value.pages-pagy.value.pageが1以下の時はpaginationクラスのdiv配下にあるnext-buttonクラスを持ったボタンにd-noneクラスを足す
  if (pagy.value.pages - pagy.value.page <= 1) {
    const nextButton = paginationDiv?.querySelector('.next-button');
    if (nextButton) {
      nextButton.classList.add('d-none');
    }
  }

  if (pagy.value.page >= 4 && pagy.value.pages - pagy.value.page >= 2) return 3;
  return 4;
};

const title = computed(() => {
  return getPageTitle(getDisplayName.value);
});

const description = computed(() => {
  return getPageDescription(getDisplayName.value);
});

const keywords = computed(() => {
  const baseKeywords =
    '社内SE,転職,求人,IT転職,エージェント,IT,エンジニア,情報システム,転職支援,社内SE転職,求人紹介,転職サポート';
  return getDisplayName.value ? `${getDisplayName.value},${baseKeywords}` : baseKeywords;
});

const url = computed(() => {
  return window.location.origin + route.fullPath;
});

watch([title, description], () => {
  // メタタグの更新はuseHeadで自動的に行われるため、ここでは何もしない
});

watch(
  () => route.query,
  () => {
    // ルートクエリの変更はuseHeadで自動的に処理されるため、ここでは何もしない
  },
  { deep: true }
);

useHead({
  title,
  meta: [
    {
      name: 'description',
      content: description,
    },
    {
      name: 'keywords',
      content: keywords,
    },
    {
      property: 'og:site_name',
      content: '社内SE転職ナビ',
    },
    {
      property: 'og:image',
      content: 'https://se-navi.jp/ogp_se.png',
    },
    {
      property: 'og:title',
      content: title,
    },
    {
      property: 'og:description',
      content: description,
    },
    {
      property: 'og:url',
      content: url,
    },
    {
      property: 'twitter:image',
      content: 'https://se-navi.jp/ogp_se.png',
    },
    {
      name: 'twitter:title',
      content: title,
    },
    {
      name: 'twitter:description',
      content: description,
    },
  ],
});
</script>
<style lang="scss">
.no-bounce-x {
  @media screen and (max-width: 767px) {
    overflow-y: auto;
    overflow-x: hidden;
  }
}

.agent-search-skelton-body {
  min-height: 80vh;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
